import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { FirestoreReference, Course, Season } from 'src/app/Classes/schema';
import { AnwService } from 'src/app/Services/ANW/anw.service';
import { MatDialog } from '@angular/material/dialog';
import { NewCourseComponent } from '../course/new-course/new-course.component';

@Component({
  selector: 'app-season',
  templateUrl: './season.component.html',
  styleUrls: ['./season.component.css']
})
export class SeasonComponent implements OnInit, OnDestroy {
  seasonId: string;
  season: FirestoreReference<Season>;
  season$: Subscription;
  seasonNumber: number;
  courses: FirestoreReference<Course>[];
  courses$: Subscription;

  constructor(
    private anw: AnwService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {
    console.log("Season loaded");
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.seasonId = params.get("seasonId");
      this.season$ = this.anw.getSeason(this.seasonId).subscribe(ref =>{
        this.season = ref;
      });
      this.season = this.anw.initSeason();

      this.courses = this.anw.initCourses();
      this.courses$ = this.anw.getCourses(this.seasonId).subscribe(refs =>{
        this.courses = refs;
      });
    }).unsubscribe();
  }

  courseModal() {
    this.anw.log("--season")
    this.anw.log(this.season);
    this.dialog.open(NewCourseComponent, {
      width: '500px',
      data: { season: this.season }
    })
  }

  ngOnDestroy(){
    this.courses$.unsubscribe();
    this.season$.unsubscribe();
  }
}
